import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to hide unloadTime from order detail screen
 */
@Injectable()
export class HideUnloadTimeFeature implements IFlagFeature {
  name = Features.HIDE_UNLOAD_TIME;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
